import { all, fork } from "redux-saga/effects"

//Layout
import LayoutSaga from "./Layout/saga";


export default function* rootSaga() {
  yield all([
    //public
    fork(LayoutSaga),
  ])
}
